/*
src/ui-panels/ForegroundImagesPanel.js
wgbh-skydiagram-testing
astro.unl.edu
2019-06-16
*/


import * as React from 'react';

import {Callout} from '@blueprintjs/core';

import {ImagesList} from '../ui-misc/ImagesList.js';


export class ForegroundImagesPanel extends React.Component {


	constructor(props) {
		super(props);

		this.forceRender = this.forceRender.bind(this);
		
		this._fobjImageBank = this.props.workspace.getForegroundObjectsImageBank();

		this._fobjImageBank.registerCallback('change', this.forceRender);

		this.state = {
			dirtyCount: 1,
		};
	}


	forceRender() {
		this.setState(state => ({dirtyCount: state.dirtyCount+1}));
	}


	render() {
	
		return (

			<div style={{maxWidth: "750px", margin: "30px auto"}}>

				<Callout intent="primary">
					Add SVG source images here, then use them in the Foreground Objects panel.
				</Callout>
		
				<ImagesList bank={this._fobjImageBank} />
			
			</div>
		);
	}

}


